import { FC } from "react";
import { styled, CircularProgress } from "@mui/material";

const LoaderContainer = styled("div")`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const DivSizeMap = {
  small: "25vh",
  medium: "50vh",
  large: "100%",
};
interface PageLoaderProps {
  size?: "small" | "medium" | "large";
  width?: string | undefined;
}
export const PageLoader: FC<PageLoaderProps> = ({ size, width }) => (
  <LoaderContainer
    sx={{
      height: DivSizeMap[size || "large"],
      width: width || "100%",
    }}
  >
    <CircularProgress size="5rem" />
  </LoaderContainer>
);
